export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8188.0620ff51.jpg";